import React from 'react';

const footer = () => (
  <footer>
    <div className="App"> © Todos os Direitos Reservados - 2020.</div>
  </footer>
);

export default footer;
